import { SHOW_POPUP } from './actions';

const DefaultState = {
  active: false, //{address: '', coords: []}
  items: [
  ],
  pixel: [],
  coords: [],
  title: '',
  address: null
};

const popup = (state = DefaultState, action) => {
  switch (action.type) {
    case SHOW_POPUP:
     
     if(action.data) {
        var newstate = {
          active: (action.data ? true : false), 
       //   pixel: (action.data ? action.data.pixel : []), 
          items: action.data.items,
          title: action.data.title,
          coords: (action.data ? action.data.coords : [])
        };
     } else {
        var newstate = {
          active: false,
          pixel: [],
          items: [],
          coords: [],
          title: '',
          address: null
        };
     }


      return Object.assign({}, state, newstate);
    default:
      return state;
  }
};

export {popup};